export default __webpack_public_path__ + "baa07949a801be2a3e3371afec807c2b.png";